<template>
  <div class="container">
    <h1 v-bg-typography="'h1'">Sections</h1>
    <p v-bg-typography="'body-m'">
      Overview of the top ten sections and their emotion scores.
      <a
        href="https://braingineers.crunch.help/dashboard-faq/sections"
        target="_blank"
        class="link"
        >Read more</a
      >.
    </p>
    <div class="filters-and-averages" v-if="chartData.datasets">
      <div class="filters-container2">
        <div class="filter-container">
          <bg-filter-bubble
            class="filter"
            v-for="filter in filters"
            :key="filter"
            :text="filter"
            :variant="filter"
            :active="activeFilters.includes(filter)"
            @click.native="toggleFilter($event, filter)"
          />
        </div>
      </div>
    </div>
    <div class="chart-container">
      <div class="yLabel">Emotions</div>
      <bg-journey-chart
        v-if="this.groups"
        :labels="fullGroups"
        :chartData="chartData"
      />
      <div class="xLabel">Sections</div>
    </div>
  </div>
</template>

<style scoped>
.container {
  max-width: 80%;
}
.filter-container {
  display: flex;
  flex-direction: row;
  margin: 40px 0;
}
.filter {
  margin-right: 12px;
}
.filters-and-averages {
  display: flex;
  justify-content: space-between;
}
.info-title {
  margin-bottom: 0;
}
.link {
  color: var(--bg-color-text-link);
}
.chart-container {
  padding: 20px;
  position: relative;
}

.yLabel {
  position: absolute;
  top: 50%;
  transform: rotate(270deg) translateY(-50%) translateX(50%);
  left: -40px;
  color: var(--bg-color-text-secondary);
  font-weight: 200;
}

.xLabel {
  position: absolute;
  bottom: -40px;
  left: 50%;
  font-weight: 200;
  color: var(--bg-color-text-secondary);
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgJourneyChart from "@/components/bg-journey-chart";
import BgFilterBubble from "@/components/bg-filter-bubble";
import BgPercentage from "@/filters/bg-percentage";

import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "journey",
  components: {
    BgJourneyChart,
    BgFilterBubble,
  },
  directives: {
    BgTypography,
  },
  filters: {
    BgPercentage,
  },
  data() {
    return {
      filters: ["frustration", "joy", "attention"],
      activeFilters: [],
      groups: [],
      fullGroups: [],
    };
  },
  computed: {
    chartData() {
      const filteredGroups = this.groups
        .filter((g) => g.joy !== 0)
        .slice(0, 10);
      this.isPageLoading = false;
      const colours = {
        joy: "#00deab",
        attention: "#ffaa00",
        frustration: "#FF00A9",
      };
      const borderColours = {
        joy: "#00deab",
        attention: "#ffaa00",
        frustration: "#FF00A9",
      };

      this.fullGroups = filteredGroups;

      const labels = filteredGroups.map((g) => g.name);

      const datasets = [];

      this.filters
        .filter(
          (f) =>
            this.activeFilters.includes(f) || this.activeFilters.length === 0
        )
        .forEach((e) => {
          datasets.push({
            label: e,
            borderWidth: 2,
            backgroundColor: colours[e],
            borderColor: borderColours[e],
            data: filteredGroups.map((g) => Math.round(g[e] * 100)),
          });
        });

      return {
        labels,
        datasets,
      };
    },
    ...mapState({
      testState: (state) => state.test,
    }),
  },
  methods: {
    toggleFilter(event, filter) {
      if (this.activeFilters.includes(filter)) {
        this.activeFilters = this.activeFilters.filter((f) => f !== filter);
      } else {
        this.activeFilters.push(filter);
      }
    },
  },
  created() {
    API.test.getPages(this.$route.params.id).then((data) => {
      const { labels } = data;
      this.groups = labels;
    });
  },
};
</script>
